import { VoidReturn } from '~/ts-utils';
import { fetchInitialData, createReview, requestLoginAction } from '../common/store/actions';
import { navigateToThankYou } from '../common/store/actions/navigation-actions';
import {
  initializeBaseParams,
  setBaseParams,
} from '../common/store/base-params/base-params-actions';
import {
  biClickLeaveReviewBtn,
  biFocusFormBody,
  biFormValidationError,
  biClickPublishReview,
} from '../common/store/actions/bi-actions';

export const controllerActions = {
  fetchInitialData,
  createReview,
  setBaseParams,
  navigateToThankYou,
  requestLoginAction,
  initializeBaseParams,
  biFormValidationError,
  biClickLeaveReviewBtn,
  biFocusFormBody,
  biClickPublishReview,
};

export type ControllerActions = {
  [key in keyof typeof controllerActions]: VoidReturn<(typeof controllerActions)[key]>;
};
